import React from 'react'

import PropTypes from 'prop-types'
import { IconSLIWrapper } from './IconSLIWrapper'

export const Icon60CheckCircle2 = ({
  className,
  'data-mu-test': dataAttributeTest,
  'data-tip': dataTip
}) => {
  return (
    <IconSLIWrapper
      className={className}
      data-mu-test={dataAttributeTest}
      data-tip={dataTip}
    >
      <svg preserveAspectRatio='xMidYMid' viewBox='0 0 47.906 47.906'>
        <path
          shapeRendering='geometricPrecision'
          fill='currentColor'
          fillRule='evenodd'
          d='M47.640,1.666 L22.699,30.598 C22.524,30.802 22.273,30.926 22.004,30.943 C21.984,30.944 21.964,30.945 21.944,30.945 C21.697,30.945 21.457,30.853 21.273,30.686 L10.298,20.709 C9.891,20.338 9.861,19.707 10.232,19.299 C10.602,18.892 11.232,18.862 11.641,19.231 L21.857,28.519 L46.129,0.363 C46.490,-0.054 47.120,-0.100 47.536,0.260 C47.954,0.620 48.000,1.248 47.640,1.666 ZM29.518,7.463 C27.165,6.413 25.042,6.003 21.944,6.003 C10.942,6.003 1.991,14.954 1.991,25.957 C1.991,36.958 10.942,45.910 21.944,45.910 C32.946,45.910 41.897,36.958 41.897,25.957 C41.897,23.747 41.542,22.258 40.887,20.285 C40.714,19.761 40.997,19.197 41.520,19.024 C42.046,18.849 42.608,19.133 42.781,19.657 C43.485,21.777 43.892,23.488 43.892,25.957 C43.892,38.059 34.046,47.904 21.944,47.904 C9.842,47.904 -0.004,38.059 -0.004,25.957 C-0.004,13.854 9.842,4.008 21.944,4.008 C25.304,4.008 27.734,4.481 30.332,5.640 C30.835,5.865 31.060,6.456 30.836,6.959 C30.612,7.462 30.022,7.687 29.518,7.463 Z'
        />
      </svg>
    </IconSLIWrapper>
  )
}

Icon60CheckCircle2.propTypes = {
  className: PropTypes.string,
  'data-mu-test': PropTypes.string,
  'data-tip': PropTypes.string
}
